import React, { useEffect, useRef } from "react";
import { motion, useAnimation, useInView } from "framer-motion";

export default function Bulb({ dimension = "150" }) {
  const controls = useAnimation();
  const iconRef = useRef(null);
  const isInView = useInView(iconRef, { once: true });
  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView]);

  const iconPath = {
    hidden: {
      pathLength: 0,
      stroke: "var(--secondary)",
    },
    visible: {
      pathLength: 1,
      stroke: [
        "var(--secondary)",
        "var(--secondary)",
        "var(--secondary)",
        "var(--secondary)",
        "var(--primary)",
      ],
      transition: {
        duration: 2,
        ease: "easeInOut",
      },
    },
  };
  return (
    <motion.svg
      width={dimension}
      height={dimension}
      viewBox="0 0 500 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={iconRef}
      initial="hidden"
      animate={controls}
    >
      <motion.path
        variants={iconPath}
        strokeWidth="15"
        d="M250 109.375C217.291 110.756 186.292 124.368 163.143 147.518C139.993 170.667 126.381 201.666 125 234.375C125.255 267.515 138.038 299.332 160.781 323.438C168.606 329.674 175.029 337.489 179.632 346.373C184.236 355.257 186.917 365.011 187.5 375C187.5 379.144 189.146 383.118 192.076 386.049C195.007 388.979 198.981 390.625 203.125 390.625H296.875C301.019 390.625 304.993 388.979 307.924 386.049C310.854 383.118 312.5 379.144 312.5 375C312.99 365.068 315.6 355.356 320.155 346.516C324.709 337.677 331.103 329.914 338.906 323.75C350.632 312.051 359.873 298.104 366.075 282.746C372.277 267.388 375.313 250.935 375 234.375C375.013 217.42 371.648 200.633 365.103 184.992C358.557 169.352 348.961 155.172 336.875 143.281C325.395 132.111 311.792 123.355 296.871 117.531C281.949 111.708 266.012 108.934 250 109.375ZM317.813 301.25C300.111 316.308 287.774 336.705 282.656 359.375H217.344C212.273 336.916 200.243 316.629 182.969 301.406C166.043 283.158 156.518 259.262 156.25 234.375C157.356 209.867 167.588 186.658 184.936 169.311C202.283 151.963 225.492 141.731 250 140.625C261.888 140.213 273.736 142.216 284.827 146.513C295.919 150.81 306.024 157.311 314.531 165.625C323.737 174.559 331.065 185.243 336.082 197.05C341.1 208.856 343.707 221.547 343.75 234.375C344.026 246.719 341.833 258.994 337.298 270.478C332.763 281.963 325.979 292.425 317.344 301.25H317.813Z"
      />
      <motion.path
        variants={iconPath}
        strokeWidth="15"
        d="M296.875 406.25H203.125C198.981 406.25 195.007 407.896 192.076 410.826C189.146 413.757 187.5 417.731 187.5 421.875C187.5 426.019 189.146 429.993 192.076 432.924C195.007 435.854 198.981 437.5 203.125 437.5H296.875C301.019 437.5 304.993 435.854 307.924 432.924C310.854 429.993 312.5 426.019 312.5 421.875C312.5 417.731 310.854 413.757 307.924 410.826C304.993 407.896 301.019 406.25 296.875 406.25Z"
      />
      <motion.path
        variants={iconPath}
        strokeWidth="15"
        d="M281.25 453.125H218.75C214.606 453.125 210.632 454.771 207.701 457.701C204.771 460.632 203.125 464.606 203.125 468.75C203.125 472.894 204.771 476.868 207.701 479.799C210.632 482.729 214.606 484.375 218.75 484.375H281.25C285.394 484.375 289.368 482.729 292.299 479.799C295.229 476.868 296.875 472.894 296.875 468.75C296.875 464.606 295.229 460.632 292.299 457.701C289.368 454.771 285.394 453.125 281.25 453.125Z"
      />
      <motion.path
        variants={iconPath}
        strokeWidth="15"
        d="M250 78.125C254.144 78.125 258.118 76.4788 261.049 73.5485C263.979 70.6183 265.625 66.644 265.625 62.5V31.25C265.625 27.106 263.979 23.1317 261.049 20.2015C258.118 17.2712 254.144 15.625 250 15.625C245.856 15.625 241.882 17.2712 238.951 20.2015C236.021 23.1317 234.375 27.106 234.375 31.25V62.5C234.375 66.644 236.021 70.6183 238.951 73.5485C241.882 76.4788 245.856 78.125 250 78.125Z"
      />
      <motion.path
        variants={iconPath}
        strokeWidth="15"
        d="M78.125 218.75H46.875C42.731 218.75 38.7567 220.396 35.8265 223.326C32.8962 226.257 31.25 230.231 31.25 234.375C31.25 238.519 32.8962 242.493 35.8265 245.424C38.7567 248.354 42.731 250 46.875 250H78.125C82.269 250 86.2433 248.354 89.1735 245.424C92.1038 242.493 93.75 238.519 93.75 234.375C93.75 230.231 92.1038 226.257 89.1735 223.326C86.2433 220.396 82.269 218.75 78.125 218.75Z"
      />
      <motion.path
        variants={iconPath}
        strokeWidth="15"
        d="M453.125 218.75H421.875C417.731 218.75 413.757 220.396 410.826 223.326C407.896 226.257 406.25 230.231 406.25 234.375C406.25 238.519 407.896 242.493 410.826 245.424C413.757 248.354 417.731 250 421.875 250H453.125C457.269 250 461.243 248.354 464.174 245.424C467.104 242.493 468.75 238.519 468.75 234.375C468.75 230.231 467.104 226.257 464.174 223.326C461.243 220.396 457.269 218.75 453.125 218.75Z"
      />
      <motion.path
        variants={iconPath}
        strokeWidth="15"
        d="M404.687 79.6874C401.76 76.7773 397.8 75.1438 393.672 75.1438C389.544 75.1438 385.584 76.7773 382.656 79.6874L360.469 101.719C359.004 103.171 357.842 104.899 357.049 106.803C356.255 108.707 355.847 110.75 355.847 112.812C355.847 114.875 356.255 116.917 357.049 118.821C357.842 120.725 359.004 122.454 360.469 123.906C361.929 125.354 363.66 126.5 365.564 127.278C367.468 128.055 369.506 128.449 371.562 128.437C373.619 128.449 375.657 128.055 377.561 127.278C379.465 126.5 381.196 125.354 382.656 123.906L404.687 101.719C407.598 98.7911 409.231 94.831 409.231 90.7031C409.231 86.5752 407.598 82.615 404.687 79.6874Z"
      />
      <motion.path
        variants={iconPath}
        strokeWidth="15"
        d="M139.531 123.906C140.996 122.454 142.158 120.726 142.951 118.822C143.745 116.918 144.153 114.875 144.153 112.813C144.153 110.75 143.745 108.708 142.951 106.804C142.158 104.9 140.996 103.171 139.531 101.719L117.344 79.6876C114.355 77.1278 110.51 75.7902 106.577 75.9421C102.645 76.094 98.9146 77.7242 96.1318 80.5069C93.3491 83.2896 91.7189 87.0199 91.567 90.9524C91.4151 94.8848 92.7527 98.7297 95.3125 101.719L117.344 123.906C118.804 125.354 120.535 126.5 122.439 127.278C124.343 128.055 126.381 128.449 128.438 128.438C130.494 128.449 132.532 128.055 134.436 127.278C136.34 126.5 138.071 125.354 139.531 123.906Z"
      />
    </motion.svg>
  );
}
